<template>
    <v-navigation-drawer
            v-model="model"
            width="340px"
            style="font-family: Roboto, sans-serif; z-index: 1; padding-top: 90px !important; padding-bottom: 90px !important;"
            app
            right
            floating :permanent="!isMobile"
            class="transparent pl-3 pr-2 pb-3"
            expand-on-hover
            :mobile-break-point="1120"
    >
        <attention-summary :event="summaryEvent" />

    </v-navigation-drawer>
</template>

<script>
    import AttentionSummary from '../AttentionSummary'
    import {mapMutations, mapState} from 'vuex'

    export default{
        components: {AttentionSummary},
        data(){
            return {
                evt: null
            }
        },
        methods: {
            ...mapMutations('clientAttention', [
                'showAttentionSummaryDrawer',
                'hideAttentionSummaryDrawer',
            ])
        },
        computed:{
            ...mapState('clientAttention', {
                summaryEvent: state => state.summaryEvent,
                drawer: state => state.attentionSummaryDrawer

            }),
            model: {
                get(){
                    return this.drawer
                },
                set(val){
                    if(val){
                        this.showAttentionSummaryDrawer()
                    }else{
                        this.hideAttentionSummaryDrawer()
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .attention-summary{

    }
</style>